export default {
  itemServiceCreate: "/cms/item/create", // 服务项目管理-新增
  itemServiceEdit: "/cms/item/edit", // 服务项目管理-编辑
  itemServicePage: "/cms/item/page", // 服务项目管理-分页查询
  itemServiceExport: "/cms/item/export", // 服务项目导出
  itemServiceStatus: "/cms/item/status", // 服务项目管理-启用停用
  itemServiceStatusCheck: "/cms/item/check/order", // 服务项目管理-停用校验
  itemServiceView: "/cms/item/view", // 服务项目管理-查看
  itemServiceList: "/cms/provider/service/list", // 服务项目管理-供应商及服务列表
  userPage: "/cms/user/page", // 用户档案-分页查询
  userOrderPage: "/cms/user/order/page", // 用户档案-体检服务记录分页查询
  userProfileId: "/cms/user/profileId", // 用户档案-查询用户profileId
  providerPage: "/cms/provider/page", // 供应商管理-分页查询
  providerRatePage: "/cms/provider/rate/page", // 供应商管理-分页查询

  userAbnormalPage: "/cms/user/abnormal/page", // 异常指标解读分页查询
  providerItemList: "/cms/provider/item/list", // 供应商-服务项目列表
  itemOptions: "/cms/item/option", // 产品级非产品级项目

  rightsCardPage: "/cms/rightsCard/page",
  rightsCardExport: "/cms/rightsCard/export",
  rightsCardView: "/cms/rightsCard/view",
  rightsCardCreate: "/cms/rightsCard/create",
  rightsCardEdit: "/cms/rightsCard/edit",
  rightsCardStatus: "/cms/rightsCard/status",
  rightsCardItemOptions: "/cms/rightsCard/itemOptions",
  rightsCardWhitelistPage: "/cms/rightsCard/whitelist/page",
  rightsCardWhitelistCreate: "/cms/rightsCard/whitelist/create",
  rightsCardWhitelistBatchStatus: "/cms/rightsCard/whitelist/batchStatus",
  rightsCardWhitelistStatus: "/cms/rightsCard/whitelist/status",
  rightsCardWhitelistFamily: "/cms/rightsCard/whitelist/family",
  rightsCardWhitelistTemplate: "/cms/rightsCard/whitelist/template",
  rightsCardWhitelistImport: "/cms/rightsCard/whitelist/import",
  rightsCardCodeBatchPage: "/cms/rightsCard/code/batch/page",
  rightsCardCodePage: "/cms/rightsCard/code/page",
  rightsCardCodeGenerate: "/cms/rightsCard/code/generate",
  rightsCardCodeExport: "/cms/rightsCard/code/export",
  rightsCardCodeVoid: "/cms/rightsCard/code/void",
};